import { useEffect, useState } from "react";
import type { FormEvent } from "react";
import { useNavigate, useParams } from "react-router-dom";

import { acceptInvitation, checkInvitation } from "../api/auth";
import { useAuthStore } from "../store/auth";

export default function AcceptInvitePage() {
  const { token = "" } = useParams();
  const [email, setEmail] = useState("");
  const [valid, setValid] = useState<boolean | null>(null);
  const [alreadyAccepted, setAlreadyAccepted] = useState(false);
  const [password, setPassword] = useState("");
  const [displayName, setDisplayName] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const setUser = useAuthStore((s) => s.setUser);
  const nav = useNavigate();

  useEffect(() => {
    checkInvitation(token).then(
      (r) => {
        setEmail(r.email);
        setValid(r.is_valid);
        setAlreadyAccepted(!!r.already_accepted);
      },
      () => { setValid(false); setError("Invitación no encontrada."); },
    );
  }, [token]);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      const user = await acceptInvitation(token, password, displayName);
      setUser(user);
      nav("/", { replace: true });
    } catch (err: any) {
      setError(err?.response?.data?.detail || JSON.stringify(err?.response?.data) || "Error al aceptar.");
    } finally {
      setLoading(false);
    }
  }

  if (valid === null) return <div className="auth-shell">Comprobando invitación…</div>;
  if (!valid && alreadyAccepted) return (
    <div className="auth-shell">
      <div className="auth-card">
        <h1>Ya tienes cuenta</h1>
        <p className="subtitle">
          {email
            ? <>La invitación para <strong>{email}</strong> ya fue usada.</>
            : <>Esta invitación ya fue usada.</>} Entra con tu contraseña.
        </p>
        <button className="primary" style={{ width: "100%", marginTop: 16 }}
                onClick={() => nav("/login", { replace: true })}>
          Ir a iniciar sesión
        </button>
      </div>
    </div>
  );
  if (!valid) return (
    <div className="auth-shell">
      <div className="auth-card">
        <h1>Invitación no válida</h1>
        <p className="subtitle">{error || "Caducada o ya usada."}</p>
      </div>
    </div>
  );

  return (
    <div className="auth-shell">
      <form className="auth-card" onSubmit={onSubmit}>
        <h1>Crear cuenta</h1>
        <p className="subtitle">Hola {email} 👋 Termina de crear tu cuenta.</p>

        <div className="field">
          <label className="label">Email</label>
          <input value={email} disabled />
        </div>
        <div className="field">
          <label className="label" htmlFor="dn">Tu nombre (opcional)</label>
          <input id="dn" value={displayName} onChange={(e) => setDisplayName(e.target.value)} />
        </div>
        <div className="field">
          <label className="label" htmlFor="pw">Contraseña (mín. 8 caracteres)</label>
          <input id="pw" type="password" autoComplete="new-password" required minLength={8}
                 value={password} onChange={(e) => setPassword(e.target.value)} />
        </div>

        {error && <div className="error-text">{error}</div>}

        <button type="submit" className="primary" disabled={loading} style={{ width: "100%" }}>
          {loading ? "Creando…" : "Crear mi cuenta"}
        </button>
      </form>
    </div>
  );
}
